import { providerDisplayLabel } from "../../shared/providerIcons";
import { PROVIDER_ORDER, toAnalyseProvider } from "./providerMap";

export function engineLabel(provider) {
	return providerDisplayLabel(provider);
}

export function resolveWonBySummary(strategy) {
	const topCompetitor = [...(strategy.competitors ?? [])].sort(
		(a, b) => b.mention_count - a.mention_count
	)[0];

	if (topCompetitor?.name) {
		const leadingProvider = PROVIDER_ORDER.find((p) => {
			const key = p === "openai" ? "chatgpt" : p;
			return topCompetitor.provider_presence?.[key]?.mentioned;
		});
		return {
			label: topCompetitor.name,
			provider: leadingProvider ?? null,
		};
	}

	for (const row of strategy.providers ?? []) {
		if (row.primary_winner) {
			return {
				label: row.primary_winner,
				provider: toAnalyseProvider(row.provider),
			};
		}
	}

	return null;
}
